/**
 * TipoOcorrencia
 * @author Simpli CLI generator
 */
import {
    $,
    Collection,
    HttpBody,
    HttpIgnore,
    ID,
    IResource,
    Resource,
    ResponseSerialize,
    TAG,
    WholeCollection,
} from 'simpli-web-sdk'
import {
    ValidationMaxLength,
    ValidationRequired,
} from 'simpli-web-sdk'
import ChecklistEntregaSchema from '@/schema/ChecklistEntrega.schema'
import Responsavel from '@/model/resource/Responsavel'
import TipoChecklistEntrega from '@/model/resource/TipoChecklistEntrega'

export default class ChecklistEntrega extends Resource {
    get $schema() {
        return ChecklistEntregaSchema(this)
    }

    get $id() {
        return this.idCheckListEntregaPk
    }
    set $id(val: ID) {
        this.idCheckListEntregaPk = val
    }
    get $tag() {
        return this.descricao
    }
    set $tag(val: TAG) {
        this.descricao = val
    }

    static async persistLoteTipoOcorrencia(listToPersist: ChecklistEntrega[],
                                           spinner = 'persistLoteChecklistEntrega') {
        const fetch = async () => {
            return await new HttpBody(Number).POST(`/user/lote-checklist-entrega`, listToPersist)
        }

        return await $.await.run(fetch, spinner)
    }

    readonly $name: string = 'ChecklistEntrega'

    readonly $endpoint: string = '/user/checklist-entrega{/id}'

    @ResponseSerialize(Responsavel)
    responsavel: Responsavel | null = null

    @ResponseSerialize(TipoChecklistEntrega)
    tipoChecklistEntrega: TipoChecklistEntrega = new TipoChecklistEntrega()

    idCheckListEntregaPk: ID = 0

    idOcorrenciaExterna: number | null = null

    codigoServico: string | null = null

    list: TipoChecklistEntrega[]  = []

    @ValidationRequired()
    descricao: string = ''

    @ValidationRequired()
    ativo: boolean = false

    msgEdicao: string | null = null

    @ValidationRequired()
    ehEditavel: boolean = false

    async persistChecklistEntrega(spinner = 'persistChecklistEntrega') {
        const fetch = async () => {
            await this.validate()
            return await this.POST(`/user/checklist-entrega`, this)
        }

        return await $.await.run(fetch, spinner)
    }

    async getChecklistEntrega(id: ID, spinner = 'getChecklistEntrega') {
        const fetch = async () => await this.GET(`/user/checklist-entrega/${id}`)
        return await $.await.run(fetch, spinner)
    }

    async removeChecklistEntrega(id: number, spinner = 'removeChecklistEntrega') {
        const fetch = async () => await this.DELETE(`/user/checklist-entrega/${id}`)
        return await $.await.run(fetch, spinner)
    }

    get tipoChecklistResource() {
        return this.tipoChecklistEntrega
    }

    set tipoChecklistResource(val: TipoChecklistEntrega) {
        this.tipoChecklistEntrega = val
    }
}
